import styled from 'styled-components'
import { TBButton } from '../../Commons/Buttons/TBButton.react'

export const GenerateButton = styled(TBButton)`
  height: 41px;
`

export const Text = styled.p`
  color: #3b3b3b;
  font-size: 16px;
`

export const SmallText = styled.p`
  font-size: 14px;
  color: #6c6c6c;
`

export const ErrorMessage = styled.p`
  color: red;
  font-size: 14px;
`
